import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import styles from './StaticImage.scss';

export default function StaticImage(props) {
  const { image, className, style, alt } = props;

  return (
    <picture className={classnames(styles.image, className)} style={style}>
      <source
        type="image/webp"
        className={styles.picture}
        srcSet={`static/images/${image}.webp 1x,
        static/images/${image}@2x.webp 2x,
        static/images/${image}@3x.webp 3x`}
        alt={alt}
      />
      <img
        className={styles.picture}
        srcSet={`static/images/${image}.jpg 1x,
        static/images/${image}@2x.jpg 2x,
        static/images/${image}@3x.jpg 3x`}
        alt={alt}
      />
      <img
        className={styles.picture}
        srcSet={`static/images/${image}.png 1x,
        static/images/${image}@2x.png 2x,
        static/images/${image}@3x.png 3x`}
        alt={alt}
      />
    </picture>
  );
}

StaticImage.propTypes = {
  image: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  alt: PropTypes.string,
};

StaticImage.defaultProps = {
  image: '',
  className: '',
  style: {},
  alt: '',
};



// WEBPACK FOOTER //
// ./src/components/IndexPage/StaticImage.jsx